import VueTelInputPlugin from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import { telInputProps } from '@/utils/telInputDefaults'

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.use(VueTelInputPlugin, telInputProps)
})